import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IonIcon, IonItem, IonLabel, IonList, IonNote } from '@ionic/angular';

import { DiscussionModel, DiscussionRockStatusCode } from '../../../models/discussion.models';
import { DiscussionFormMode } from '../../../models/form/discussion-form.model';
import { DiscussionFormBase } from '../discussion-form-base/discussion-form-base';

@Component({
  selector: 'nty-discussion-performance-data-form',
  imports: [CommonModule, IonIcon, IonItem, IonLabel, IonList, IonNote, DatePipe],
  template: `
    <h2 class="terra-headline-3 section-heading">Performance Data</h2>
    <ion-list>
      @for (rock of discussion.rocks; track rock) {
        <ion-item class="item">
          <ion-label>
            <h3 class="item__title">
              {{ rock.title }}
            </h3>
            <p>
              {{ rock.dueDate | date: 'MMM d' }}
            </p>
          </ion-label>
          @if (rock.statusCode === RockStatus.OFF_TRACK) {
            <ion-icon aria-hidden="true" name="alert-circle" slot="end" class="icon-danger" />
          } @else if (rock.statusCode === RockStatus.ON_TRACK) {
            <ion-icon aria-hidden="true" name="thumbs-up" slot="end" class="icon-success" />
          } @else if (rock.statusCode === RockStatus.DONE) {
            <ion-icon aria-hidden="true" name="checkmark-circle" slot="end" class="icon-primary" />
          } @else {
            <ion-icon aria-hidden="true" name="alert-circle" slot="end" class="icon-warning" />
          }
        </ion-item>
      }
    </ion-list>

    <br />

    <ion-note class="ion-margin-horizontal">
      Completion Rate: {{ rocksCompleted / totalRocks | percent: '1.0-0' }}
    </ion-note>

    <ion-note class="ion-margin-horizontal">Completed: {{ rocksCompleted }} / {{ totalRocks }}</ion-note>
  `,
  styles: `
    @use 'terra';

    ion-note {
      --color: #{terra.color(text, light)};
    }

    .section-heading {
      color: terra.color(text);
    }

    .icon-danger {
      color: terra.color(red);
    }

    .icon-success {
      color: terra.color(green);
    }

    .icon-primary {
      color: terra.color(ninety);
    }

    .icon-warning {
      color: terra.color(orange);
    }

    .item {
      &::part(native) {
        background: transparent;
      }

      &__title {
        color: terra.color(text);
      }

      &__date {
        color: terra.color(text, light);
      }
    }
  `,
})
export class DiscussionPerfDataFormComponent extends DiscussionFormBase implements OnInit {
  @Input({ required: true }) discussion!: DiscussionModel;
  @Input() mode: DiscussionFormMode = DiscussionFormMode.Meeting;

  RockStatus = DiscussionRockStatusCode;

  rocksCompleted = 0;
  totalRocks = 0;

  ngOnInit() {
    this.totalRocks = this.discussion.rocks?.length ?? 0;
    if (this.totalRocks > 0) {
      this.rocksCompleted = this.discussion.rocks?.filter(r => r.statusCode === DiscussionRockStatusCode.DONE).length;
    }
  }
}
